import { makeAutoObservable, runInAction } from 'mobx';
import axios from 'axios';
import urls from './Urls';

class PermissionProfileStore {
    total = 0;
    profiles = [];
    permissionOptions = null;
    isLoading = false;

    constructor() {
        makeAutoObservable(this);
    }

    async fetchProfiles({ page, limit, filters, sort }) {
        this.isLoading = true;
        try {
            const response = await axios.post(
                urls.permissionProfile.getAll,
                { page, limit, filters, sort },
                { withCredentials: true }
            );
            runInAction(() => {
                this.profiles = response.data.data;
                this.total = response.data.total;
            });
        } catch (err) {
            throw err?.response?.data || err.message;
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    async fetchPermissionOptions() {
        try {
            if (this.permissionOptions) return this.permissionOptions;

            const response = await axios.get(urls.permissionProfile.getPermissionOptions, {
                withCredentials: true
            });

            const collections = ['*', ...response.data?.collections || []];
            const actions = ['*', ...response.data?.actions || []];
            const features = response.data?.features || [];

            const fieldsByCollection = {
                '*': ['*'],
                ...Object.fromEntries(
                    Object.entries(response.data?.fieldsByCollection || {}).map(([collection, fields]) => [
                        collection,
                        ['*', ...fields]
                    ])
                )
            };

            this.permissionOptions = { collections, actions, features, fieldsByCollection };
            return this.permissionOptions;
        } catch (err) {
            throw err?.response?.data || err.message;
        }
    }

    async createProfile(payload) {
        try {
            await axios.post(urls.permissionProfile.create, payload, {
                withCredentials: true
            });
        } catch (err) {
            throw err?.response?.data || err.message;
        }
    }

    async updateProfile(profileId, changes) {
        try {
            await axios.patch(`${urls.permissionProfile.update}/${profileId}`, changes, {
                withCredentials: true
            });
        } catch (err) {
            throw err?.response?.data || err.message;
        }
    }

    async deleteProfile(profileId) {
        try {
            await axios.delete(`${urls.permissionProfile.delete}/${profileId}`, {
                withCredentials: true
            });
        } catch (err) {
            throw err?.response?.data || err.message;
        }
    }
}

const store = new PermissionProfileStore();
export default store;
